
<a (click)="JSONToCSVConvertor(jsonData,reportData,showLabelData,titleData)"><i class="material-icons" style="cursor: pointer;">{{name}}</i></a>
